import toast from "react-hot-toast";
import { http } from "../../Utility/APIRequest";
import { FetchError, FetchStart, FetchSuccess } from "./InvoiceSlice";
import { HandleHTTPRequestError } from "../../Utility/HandleHTTPRequestError";
import { t } from "i18next";

export const FetchCollectedInvoices = (token) => async (dispatch) => {
  dispatch(FetchStart());
  // http request to backend
  try {
    const response = await http.get("api/invoice/approved/collect/paid", {
      headers: { Authorization: `Bearer ${token}` },
    });
    // console.log("how are you with collected paid")
    // console.log(response)
    toast.success(t("toast.data_fetch"));
    dispatch(FetchSuccess(response.data.records));
  } catch (error) {
    dispatch(FetchError());
    if (error.response) {
      HandleHTTPRequestError(error.response.status, error, dispatch);
    } else {
      // Handle the case where the API is offline or unreachable
      console.error("API is offline or unreachable.");
        toast.error(t("toast.apiOffline"));
    }
  }
};

export const FetchCollectedInvoiceListByBranch = (token, id) => async (dispatch) => {
  dispatch(FetchStart());
  // http request to backend
  try {
    const response = await http.get(`api/invoice/received/branch/get/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    // console.log("how are you with collected paid")
    // console.log(response)
    toast.success(t("toast.data_fetch"));
    dispatch(FetchSuccess(response.data.records));
  } catch (error) {
    dispatch(FetchError());
    if (error.response) {
      HandleHTTPRequestError(error.response.status, error, dispatch);
    } else {
      // Handle the case where the API is offline or unreachable
      console.error("API is offline or unreachable.");
        toast.error(t("toast.apiOffline"));
    }
  }
};
